"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESET_PASSWORD = exports.RESET_PASSWORD_PREP = exports.REGISTER_USER = exports.LOGIN_USER = exports.LOGIN_ADMIN = void 0;
const client_1 = require("@apollo/client");
exports.LOGIN_ADMIN = (0, client_1.gql) `
  mutation LoginAdmin($username: String!, $password: String!, $days: Int!) {
    loginAdmin(username: $username, password: $password, days: $days)
  }
`;
exports.LOGIN_USER = (0, client_1.gql) `
  mutation LoginUser($username: String!, $password: String!, $days: Int!) {
    loginUser(username: $username, password: $password, days: $days)
  }
`;
exports.REGISTER_USER = (0, client_1.gql) `
  mutation RegisterUser($userData: RegisterUser!) {
    registerUser(userData: $userData)
  }
`;
exports.RESET_PASSWORD_PREP = (0, client_1.gql) `
  mutation ResetPasswordPrep($username: String!) {
    resetPasswordPrep(username: $username)
  }
`;
exports.RESET_PASSWORD = (0, client_1.gql) `
  mutation ResetPassword($password: String!, $token: String!) {
    resetPassword(password: $password, token: $token)
  }
`;
